module.exports = function(app) {
    "use strict";
    app.controller('pages.assistEmployees.summaryOfBenefits', ["$state", "$scope", "sessionData", "services", "$window",
        function ($state, $scope, sessionData, services, $window) {

            $scope.feedback = {};
            $scope.sidebar = {
                breadCrumb : {
                    primary : {
                        title: "Assist Employees",
                        state: "assistEmployees"
                    },
                    secondary : {
                        title: "Summary Of Benefits (SBC)"
                    }
                }
            };
            $scope.objFiltering = {
                orderBy: 'groupNumber',
                reverse: false,
                titles: [
                    {
                        name: "Group Number",
                        dataKey: "groupNumber"
                    }
                ],
                arrItems: []
            };

            // ==========================================================================================
            //
            // =====   NOTE:  the code for this is in directives/filterBoxAndTableDisplay.js   ==========
            // =====   NOTE:  the route object is in assistEmployees.js                        ==========
            //
            // ==========================================================================================
        }
	]);
};

